import styles from '../styles/breadcrumb.scss';
import cx from 'classnames';
import amcStyles from '../styles/amcs.scss';

interface BreadCrumbInterface {
  link?: string;
  text: string;
}
interface Props {
  breadcrumbs: BreadCrumbInterface[];
  className: string;
  linkStyles: string;
  disableLastChild: boolean;
}
const BreadCrumb = ({
  breadcrumbs,
  className,
  linkStyles,
  disableLastChild,
}: Props) => (
  <ol
    className={cx(className, styles['breadcrumb-list'])}
    itemScope={true}
    itemType="http://schema.org/BreadcrumbList"
  >
    {breadcrumbs.map((breadcrumb, i) => (
      <li
        className={
          linkStyles
            ? linkStyles
            : disableLastChild
            ? amcStyles['breadcrumb-link']
            : ''
        }
        key={breadcrumb.text}
        itemProp="itemListElement"
        itemScope={true}
        itemType="http://schema.org/ListItem"
      >
        <a href={breadcrumb.link ? breadcrumb.link : null} itemProp="item">
          <span itemProp="name" className="hide-large-down sm:lil-hidden">
            {breadcrumb.text}
          </span>
          <span
            itemProp="name"
            className="lil-text-s-12 md:lil-hidden lg:lil-hidden xl:lil-hidden hide-large-up"
          >
            {breadcrumb.text.length > 11
              ? breadcrumb.text.slice(0, 11) + '..'
              : breadcrumb.text}
          </span>
          <meta itemProp="position" content={`${i + 1}`} />
        </a>
      </li>
    ))}
  </ol>
);

export default BreadCrumb;



// WEBPACK FOOTER //
// ./components/breadcrumb.tsx